import React from 'react'
import { createContext } from 'react'
import PropTypes from 'prop-types'
import { isFrec } from '../../Common/Utils/Portal'

export const PortalContext = createContext({ portal: 'PROMETHEUS', setPortal: () => {}, isFrec: false })

const PortalProvider = ({ dftPortal, children }) => {
  const [portal, setPortal] = React.useState(dftPortal)
  return (
    <PortalContext.Provider value={{ portal, setPortal: setPortal, isFrec: isFrec(portal) }}>
      {children}
    </PortalContext.Provider>
  )
}

PortalProvider.propTypes = {
  dftPortal: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
}

export default PortalProvider
